






























import Vue from 'vue';
import Component from 'vue-class-component';
import * as types from '@/store/types';
import { mapGetters } from 'vuex';

@Component({
    computed: mapGetters({
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS,
        routerQuery: types.USERDATA_GET_ROUTER_QUERY,
    })
})
export default class StatsContainer extends Vue {}
